<ng-template #customerCareMessage>
  <div class="support-message">{{ 'csa.customer-care.message' | translate }}</div>
</ng-template>
<div
  class="rating-container"
  [class.increased-height]="(claimingStage !== null && claimingStage !== claimingStages.STAGE5) || increaseContainersHeight"
  [ngSwitch]="claimingStage">
  <div class="rating-preview-title-non-mobile">{{ 'csa.raiting.title' | translate }}</div>
  <ng-container *ngIf="ratings !== null && claimingStage !== null && !loading">
    <!-----------------------Stage 1 -------------------------->
    <ng-container *ngSwitchCase="claimingStages.STAGE1">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
        <div class="gmb-state">{{ 'csa.raiting.no.google' | translate }}</div>
      </div>
      <div class="gmb-state-message" [innerHTML]="'csa.raiting.claim' | translate"></div>
      <ng-template *ngIf="isMacUser" [ngTemplateOutlet]="customerCareMessage"></ng-template>
      <button (click)="openClaimListingDialog()" class="primary-black-button mt-auto" [ngClass]="{ disabled: isMacUser }" [disabled]="isMacUser">
        {{ 'csa.inactive.state.button' | translate }}
      </button>
    </ng-container>

    <!-----------------------Stage 2 -------------------------->
    <ng-container *ngSwitchCase="claimingStages.STAGE2">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
        <div class="gmb-state">{{ 'csa.raiting.no.google' | translate }}</div>
      </div>
      <div class="gmb-state-message" [innerHTML]="'csa.claiming.premium.bottomsheet.interceptor.GMB_TOKEN_GIVEN.text' | translate"></div>
      <ng-template *ngIf="isMacUser" [ngTemplateOutlet]="customerCareMessage"></ng-template>
      <button (click)="openClaimListingDialog()" class="primary-black-button mt-auto" [ngClass]="{ disabled: isMacUser }" [disabled]="isMacUser">
        {{ 'csa.claiming.premium.bottomsheet.interceptor.GMB_TOKEN_GIVEN.continue' | translate }}
      </button>
    </ng-container>

    <!-----------------------Stage 3 -------------------------->

    <ng-container *ngSwitchCase="claimingStages.STAGE3">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
        <div class="gmb-state">{{ 'csa.claiming.GMB_AWAITING_OWNERSHIP_DECISION.title' | translate }}</div>
      </div>
      <div class="gmb-state-message" [innerHTML]="'csa.claiming.GMB_AWAITING_OWNERSHIP_DECISION.description' | translate"></div>
      <ng-template *ngIf="isMacUser" [ngTemplateOutlet]="customerCareMessage"></ng-template>
      <button (click)="openStage3Bottomsheet()" class="primary-black-button mt-auto" [ngClass]="{ disabled: isMacUser }" [disabled]="isMacUser">
        {{ 'csa.claiming.GMB_AWAITING_OWNERSHIP_DECISION.button' | translate }}
      </button>
    </ng-container>

    <!-----------------------Wrong type -------------------------->
    <ng-container *ngSwitchCase="claimingStages.WRONG_TYPE">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
        <div class="gmb-state">{{ 'csa.claiming.bottomsheet.interceptor.WRONG_TYPE.title' | translate }}</div>
      </div>
      <div class="gmb-state-message" [innerHTML]="'csa.claiming.bottomsheet.interceptor.WRONG_TYPE.text' | translate"></div>
      <ng-template *ngIf="isMacUser" [ngTemplateOutlet]="customerCareMessage"></ng-template>
      <button (click)="openClaimListingDialog()" class="primary-black-button mt-auto" [ngClass]="{ disabled: isMacUser }" [disabled]="isMacUser">
        {{ 'csa.claiming.bottomsheet.interceptor.WRONG_TYPE.continue' | translate }}
      </button>
    </ng-container>

    <!-----------------------Stage 4 -------------------------->
    <ng-container *ngSwitchCase="claimingStages.STAGE4">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
        <div class="gmb-state">{{ 'csa.raiting.no.google' | translate }}</div>
      </div>
      <div class="gmb-state-message" [innerHTML]="'csa.raiting.start.verification' | translate"></div>
      <ng-template *ngIf="isMacUser" [ngTemplateOutlet]="customerCareMessage"></ng-template>
      <button (click)="openClaimListingDialog()" class="primary-black-button mt-auto" [ngClass]="{ disabled: isMacUser }" [disabled]="isMacUser">
        {{ 'csa.verification-required.state.button' | translate }}
      </button>
    </ng-container>

    <!-----------------------Stage 5 -------------------------->
    <ng-container *ngSwitchCase="claimingStages.STAGE5">
      <ng-container *ngIf="nReviews > 0">
        <div class="mobile-layout">
          <span class="star filled star-mobile"> &#9733; </span>
          <span class="average-result">{{ this.getAverageFormat(ratings.average) }}</span>
          <div class="rating-stars">
            <ngb-rating [(rate)]="ratings.average">
              <ng-template let-fill="fill">
                <span class="star" [class.filled]="fill === 100"> &#9733; </span>
              </ng-template>
            </ngb-rating>
          </div>
          <span class="number-reviews-non-mobile">{{ nReviews }} {{ 'csa.raiting.reviews' | translate }}</span>
          <div class="layout-mobile-title">
            <div class="rating-preview-title">{{ 'csa.raiting.title' | translate }}</div>
            <span class="number-reviews">{{ nReviews }} {{ 'csa.raiting.reviews' | translate }}</span>
          </div>
        </div>
        <div class="separator-line"></div>
        <div class="rating-preview-subtitle-non-mobile">{{ 'csa.raiting.subtitle' | translate }}</div>
        <div class="progress-bars-container">
          <div class="progress-bar-root" *ngFor="let rate of ratingOpts">
            <div class="rating-index">
              {{ rate | uppercase | starRatingNumber }}
              <span class="filled"> &#9733; </span>
            </div>
            <div class="progress progress-bar-position">
              <div
                class="progress-bar"
                role="progressbar"
                class="progress-bar-template"
                [style.width.%]="calculatePercentage(ratings.ratings[rate])"
                aria-valuenow="raiting.average"
                aria-valuemin="0"
                aria-valuemax="nReviews"
                triggers="mouseenter:mouseleave"
                placement="top"></div>
            </div>
            <span *ngIf="ratings.ratings[rate] == 1" class="progress-bar-count"
              >{{ ratings.ratings[rate] }} {{ 'csa.raiting.review' | translate }}</span
            >
            <span *ngIf="ratings.ratings[rate] != 1" class="progress-bar-count"
              >{{ ratings.ratings[rate] }} {{ 'csa.raiting.reviews' | translate }}</span
            >
          </div>
        </div>
        <button (click)="goToReviews()" class="update-profile-button mt-auto">{{ 'csa.raiting.redirect.text' | translate | uppercase }}</button>
      </ng-container>
      <!----------------------- No reviews -------------------------->
      <ng-container *ngIf="nReviews === 0">
        <div class="logo-state-container">
          <img class="no-review-icon" src="./../../../../assets/images/icons_premium/Group 67-orange.svg" alt="Internet Presence" />
          <div class="no-rating-title" style="padding-bottom: 9px">{{ 'csa.no.reviews.rating.title' | translate }}</div>
        </div>
        <!-- <ng-container> -->
        <div class="logo-state-container">
          <img
            class="listing-check rating-stars"
            width="100px"
            height="78px"
            src="./../../../../assets/images/icons_premium/Group 67-orange.svg"
            alt="Internet Presence" />
        </div>
        <div class="gmb-state-message" [innerHTML]="'csa.no.reviews.rating.text' | translate"></div>
        <div (click)="goToProfileTab()" class="go-to-media-text">{{ 'csa.no.reviews.update.profile.link' | translate }}</div>
        <!-- </ng-container> -->
      </ng-container>
    </ng-container>

    <!----------------------- Given up -------------------------->
    <ng-container *ngSwitchCase="claimingStages.GIVEN_UP">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
        <div class="gmb-state">{{ 'csa.raiting.no.google' | translate }}</div>
      </div>
      <div class="gmb-state-message mt-md-5" [innerHTML]="'csa.raiting.not.managed.google' | translate"></div>
      <button (click)="reactivate()" class="primary-black-button mt-auto">{{ 'csa.deactivated.state.button' | translate }}</button>
    </ng-container>

    <!----------------------- Undefined -------------------------->
    <ng-container *ngSwitchCase="claimingStages.UNDEFINED">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Listing Check" />
        <div class="gmb-state">{{ 'csa.undefined' | translate }}</div>
      </div>
      <div class="gmb-state-message">{{ 'csa.undefined.message' | translate }}</div>
    </ng-container>

    <!----------------------- Lost -------------------------->
    <ng-container *ngSwitchCase="claimingStages.LOST">
      <div class="logo-state-container">
        <img class="listing-check" src="./../../../../assets/images/icons/warning-yellow.svg" alt="Warning Logo" />
        <div class="gmb-state">{{ 'csa.raiting.no.google' | translate }}</div>
      </div>
      <div class="gmb-state-message mt-md-5" [innerHTML]="'csa.raiting.not.managed.google' | translate"></div>
      <button (click)="reactivate()" class="primary-black-button mt-auto">{{ 'csa.deactivated.state.button' | translate }}</button>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="loading || claimingStage === null">
    <div class="gmb-loading">
      <csa-progress-save-spinner [size]="87" [centered]="true" [strokeWidth]="6"></csa-progress-save-spinner>
      <div class="loading-text">
        {{ 'csa.dashboard.checking.gmb' | translate }}
      </div>
    </div>
  </ng-container>
</div>
